import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import './ConfirmDeleteModal.css';

interface ConfirmDeleteModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    message?: string;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ isOpen, onConfirm, onCancel, message }) => {
    return (
        <Modal open={isOpen} onClose={onCancel}>
            <Box className="confirm-modal-box">
                <h3>{message || "Are you sure you want to delete this task?"}</h3>
                <div className="modal-actions">
                    <Button onClick={onCancel} variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} variant="contained" color="error">
                        Delete
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ConfirmDeleteModal;
